import { Fragment } from "preact";
import { safeTextParts } from "../lib/safe-text.js";

export function SafeText({ text }: { text: string }) {
  return safeTextParts(text).map((part, index) =>
    part.security ? (
      <span
        class={`unicode-control unicode-control-${part.security.kind}`}
        title={`${part.security.name} (${part.security.codePoint}); original character is not rendered`}
        key={index}
      >
        {part.text}
      </span>
    ) : (
      <Fragment key={index}>{part.text}</Fragment>
    ),
  );
}
